import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Http } from '@angular/http';
import { AdminSound } from '../models/AdminSound';
import { SwitchStatusTimes } from '../models/SwitchStatusTimes';

@Injectable()
export class SwitchStatusTimesService {
  constructor(private http: Http) {}

  get(regionId: number): Observable<any> {
    const url =
      environment.api.baseUrl +
      environment.api.switchStatusTimes.get.replace(
        '{regionId}',
        regionId.toString()
      );
    return this.http.get(url).map(res => {
      return res.json().map(j => new SwitchStatusTimes(j));
    });
  }

  save(status: SwitchStatusTimes): Observable<SwitchStatusTimes> {
    const url =
      environment.api.baseUrl + environment.api.switchStatusTimes.save;
    return this.http.post(url, status).map(res => {
      return res.json();
    });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/switch-status-times.service.ts